export default class StripeForm {
	constructor (options) {
		this.inputStyle = {
			base: {
				color: '#495057',
				fontWeight: 500,
				fontSize: '13px',
				fontSmoothing: 'antialiased',
				lineHeight: '1.0'
			}
		}

		this.inputClasses = {
			focus: 'focused',
			empty: 'empty',
			invalid: 'invalid'
		}

		// eslint-disable-next-line no-undef
		this.stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY)
		this.elements = this.stripe.elements({
			'locale': 'fr'
		})

		this.options = options

		this.card = null
		this.cvc = null
		this.exp = null

		this.disableSubmitBtn()
	}

	disableSubmitBtn () {
		window.$(this.options['submitBtnSelector']).attr('disabled', true)
	}

	enableSubmitBtn () {
		window.$(this.options['submitBtnSelector']).attr('disabled', false)
	}

	initializeForm () {
		this.createCardNumberInput()
		this.createCvcInput()
		this.createCardExpirationInput()
	}

	createCardNumberInput () {
		this.card = this.elements.create('cardNumber', {
			placeholder: '',
			style: this.inputStyle,
			classes: this.inputClasses
		})
		this.card.mount('#creditCardCardNumber')

		let _this = this

		this.card.addEventListener('change', function (event) {
			if (event.error) {
				_this.disableSubmitBtn()
			} else {
				window.$('#card-errors').html('')
				if (event.empty) {
					_this.disableSubmitBtn()
				} else {
					_this.enableSubmitBtn()
				}
			}
		})

		this.card.on('focus', function (event) {
			window.$('#creditCardCardNumber + label').addClass('active')
		})
		this.card.on('blur', function (event) {
			if (window.$('#creditCardCardNumber').hasClass('empty')) {
				window.$('#creditCardCardNumber + label').removeClass('active')
			}
		})
	}

	createCvcInput () {
		this.cvc = this.elements.create('cardCvc', {
			placeholder: '',
			style: this.inputStyle,
			classes: this.inputClasses
		})
		this.cvc.mount('#creditCardSecurityCode')

		let _this = this

		this.cvc.addEventListener('change', function (event) {
			if (event.error) {
				_this.disableSubmitBtn()
			} else {
				window.$('#card-errors').html('')
				if (event.empty) {
					_this.disableSubmitBtn()
				} else {
					_this.enableSubmitBtn()
				}
			}
		})

		this.cvc.on('focus', function (event) {
			window.$('#creditCardSecurityCode + label').addClass('active')
		})
		this.cvc.on('blur', function (event) {
			if (window.$('#creditCardSecurityCode').hasClass('empty')) {
				window.$('#creditCardSecurityCode + label').removeClass('active')
			}
		})
	}

	createCardExpirationInput () {
		this.exp = this.elements.create('cardExpiry', {
			placeholder: '',
			style: this.inputStyle,
			classes: this.inputClasses
		})
		this.exp.mount('#creditCardExpiration')

		let _this = this

		this.exp.addEventListener('change', function (event) {
			if (event.error) {
				_this.disableSubmitBtn()
			} else {
				window.$('#card-errors').html('')
				if (event.empty) {
					_this.disableSubmitBtn()
				} else {
					_this.enableSubmitBtn()
				}
			}
		})

		this.exp.on('focus', function (event) {
			window.$('#creditCardExpiration + label').addClass('active')
		})
		this.exp.on('blur', function (event) {
			if (window.$('#creditCardExpiration').hasClass('empty')) {
				window.$('#creditCardExpiration + label').removeClass('active')
			}
		})
	}

	createPaymentMethod (billingDetails) {
		return this.stripe.createPaymentMethod({
			type: 'card',
			card: this.card,
			billing_details: billingDetails
		})
	}

	confirmCardPayment (clientSecret, paymentMethodId) {
		return this.stripe.confirmCardPayment(
			clientSecret,
			{
				payment_method: paymentMethodId
			})
	}

	handleCardAction (clientSecret) {
		return this.stripe.handleCardAction(clientSecret)
	}

	confirmCardSetup (billingDetails) {
		return this.stripe.confirmCardSetup(
			this.options['clientSecret'],
			{
				payment_method: {
					card: this.card,
					billing_details: billingDetails
				}
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/services/StripeForm.js